jQuery(document).ready(function($) {

    AOS.init();

    $("a[href='#']").attr("href", "javascript:void(0)");

    jQuery(".validation_message").attr("role", "alert");
    jQuery(".gfield.name input").attr("autocomplete", "given-name");
    jQuery(".gfield.email input").attr("autocomplete", "given-email");
    jQuery(document).on('gform_page_loaded', function(event, form_id, current_page) {
        jQuery(".validation_message").attr("role", "alert");
        jQuery(".gfield.name input").attr("autocomplete", "given-name");
        jQuery(".gfield.email input").attr("autocomplete", "given-email");
    });

    $(window).scroll(function() {
        var sticky = $(".site-header"),
            scroll = $(window).scrollTop();

        if (scroll >= 1) sticky.addClass("sticky");
        else sticky.removeClass("sticky");
    });

    $(window).scroll(function() {
        var sticky = $(".header_button "),
            scroll = $(window).scrollTop();

        if (scroll >= 1) sticky.addClass("btn_deep_red");
        else sticky.removeClass("btn_deep_red");
    });

    $(".site-navigation-toggle-open").click(function() {
        $(".site-header").addClass("menu_active");
        $("body").addClass("toggle_menu_active");
    });

    $(".site-navigation-toggle-close").click(function() {
        $(".site-header").removeClass("menu_active");
        $("body").removeClass("toggle_menu_active");
    });

    $(".faq_wrapper_right_list_item_inner_question").on("click", function(e) {
        e.preventDefault();
        if ($(this).next().is(":visible")) {
            $(this).removeClass("active");
            $(this).next().slideUp();
        } else {
            $(".faq_wrapper_right_list_item_inner_answer").slideUp();
            $(".faq_wrapper_right_list_item_inner_question").removeClass("active");
            $(this).addClass("active");
            $(this).next().slideDown();
        }
    });

    jQuery(document).on(
        "click",
        ".site-header .menu-item.menu-item-has-children>a",
        function() {
            if (jQuery(this).parent().find(".sub-menu").is(":hidden")) {
                jQuery(".site-header .menu-item.menu-item-has-children>a").removeClass(
                    "active"
                );
                jQuery(
                    ".site-header .menu-item.menu-item-has-children>.sub-menu"
                ).slideUp();
                jQuery(this).addClass("active");
                jQuery(this).parent().find(".sub-menu").slideDown();
            } else {
                jQuery(this).removeClass("active");
                jQuery(this).parent().find(".sub-menu").slideUp();
            }
        }
    );

    jQuery(".gallery_slider_sec").each(function(index) {
        let slide = jQuery(this).find(".gallery_slider__item");
        let slider = jQuery(this).find(".gallery_slider");
        if (jQuery(slide).length > 1) {
            jQuery(slider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                infinite: true,
                prevArrow: jQuery(this).find(".previous_arrow"),
                nextArrow: jQuery(this).find(".next_arrow"),
                asNavFor: ".gallery_nav_slider",
            });
        }

        let nav_slide = jQuery(this).find(".gallery_nav_slider__item");
        let nav_slider = jQuery(this).find(".gallery_nav_slider");
        if (jQuery(nav_slide).length > 1) {
            jQuery(nav_slider).slick({
                slidesToShow: 12,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                infinite: true,
                asNavFor: ".gallery_slider",
                centerMode: true,
                focusOnSelect: false,
                variableWidth: true,
                responsive: [{
                        breakpoint: 1360,
                        settings: {
                            slidesToShow: 10,
                        },
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 6,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 4,
                        },
                    },
                ],
            });
        }
    });

    jQuery(".hero_banner_sec").each(function(index) {
        let slide = jQuery(this).find(".images_list__item");
        let slider = jQuery(this).find(".images_list");
        let dots = jQuery(this).find(".slider_dots");
        if (jQuery(slide).length > 1) {
            jQuery(slider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                appendDots: jQuery(dots),
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: "linear",
                autoplay: true,
                autoplaySpeed: 5000,
            });
        }
    });

    jQuery(".image_video_slider_sec").each(function(index) {
        let slide = jQuery(this).find(".content_slide");
        let slider = jQuery(this).find(".image_video_slider_sec__content_slider");
        if (jQuery(slide).length > 1) {
            jQuery(slider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: false,
                infinite: false,
                fade: true,
                arrows: false,
                cssEase: "linear",
                speed: 700,
                asNavFor: ".image_video_slider",
                swipeToSlide: false,
            });
        }
    });

    jQuery(".image_video_slider_sec").each(function(index) {
        let slide = jQuery(this).find(".image_video_slider__item");
        let slider = jQuery(this).find(".image_video_slider");
        if (jQuery(slide).length > 1) {
            jQuery(slider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                dots: false,
                infinite: false,
                arrows: true,
                prevArrow: jQuery(this).find(".previous_arrow"),
                nextArrow: jQuery(this).find(".next_arrow"),
                focusOnSelect: true,
                centerMode: true,
                swipeToSlide: false,
                cssEase: "linear",
                speed: 700,
                asNavFor: ".image_video_slider_sec__content_slider",
            });
        }
    });

    jQuery(".image_video_slider_sec .play_btn").click(function() {
        setTimeout(function() {
            jQuery(".lity").addClass("video_popup_open");
            jQuery("body").addClass("video_popup_active");
        });
    });

    jQuery(document).on("lity:close", function(event, instance) {
        jQuery(".lity").removeClass("video_popup_open");
        jQuery("body").removeClass("video_popup_active");
    });

    jQuery(".content_with_video_sec").each(function(index) {
        jQuery(".content_with_video_sec .media.file_video .play_btn").click(
            function() {
                jQuery(".content_with_video_sec .media.file_video .poster_image").hide();
                jQuery(".content_with_video_sec .media.file_video .play_btn").hide();
                jQuery(".content_with_video_sec .media.file_video .video_type").show();
                jQuery(".content_with_video_sec .media.file_video .video_type").addClass("video_active");
                jQuery(".content_with_video_sec .media.file_video .video_type")
                    .find("video")
                    .attr("autoplay", "autoplay");
                jQuery(".content_with_video_sec .media.file_video .video_type")
                    .find("video")
                    .get(0)
                    .play();
            }
        );
        jQuery(".content_with_video_sec .media.url_video .play_btn").click(
            function() {
                jQuery(".content_with_video_sec .media.url_video .poster_image").hide();
                jQuery(".content_with_video_sec .media.url_video .play_btn").hide();
                jQuery(".content_with_video_sec .media.url_video .video_type").show();
                jQuery(".content_with_video_sec .media.url_video .video_type").addClass("video_active");
                var videoURL = jQuery("iframe").prop("src");
                videoURL += "&autoplay=1";
                jQuery("iframe").prop("src", videoURL);
            }
        );
    });

    jQuery(".slider_grid").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        autoplay: false,
        variableWidth: true,
        arrows: true,
        prevArrow: $(".left_button"),
        nextArrow: $(".right_button"),
        responsive: [{
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    offsetSliderLeft();
    jQuery(window).resize(function(jQuery) {
        offsetSliderLeft();
    });

    function offsetSliderLeft() {
        if (jQuery(".history_slider_sec .slider_main__inner").length > 0) {
            var applicationsoffset = jQuery(
                    ".history_slider_sec .slider_main__inner"
                ).offset(),
                applicationswindWidth = jQuery(window).width();
            jQuery(".history_slider_sec .slider_main__inner").css(
                "width",
                applicationswindWidth - applicationsoffset.left
            );
        }
    }

    jQuery(".images_slider_with_content").each(function(index) {
        let image_slider = jQuery(this).find(
            ".images_slider_with_content_inner_wrapper.content_static .images_slider"
        );
        let image_nav_slider = jQuery(this).find(
            ".images_slider_with_content_inner_wrapper.content_slide .images_slider"
        );
        let content_slider = jQuery(this).find(
            ".content_section_slider.content_slide"
        );
        let next_arrow = jQuery(this).find(
            ".images_slider_with_content_inner .next_arrow"
        );
        let prev_arrow = jQuery(this).find(
            ".images_slider_with_content_inner .prev_arrow"
        );
        let dots = jQuery(this).find(".slick_custom_dots");
        jQuery(image_slider).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            variableWidth: true,
            centerMode: true,
            centerPadding: "0",
            speed: 600,
            dots: true,
            arrows: true,
            appendDots: jQuery(dots),
            prevArrow: jQuery(prev_arrow),
            nextArrow: jQuery(next_arrow),
            responsive: [{
                breakpoint: 768,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                },
            }, ],
        });
        jQuery(image_nav_slider).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            variableWidth: true,
            centerMode: true,
            appendDots: jQuery(dots),
            centerPadding: "0",
            speed: 600,
            dots: true,
            arrows: true,
            prevArrow: jQuery(prev_arrow),
            nextArrow: jQuery(next_arrow),
            asNavFor: jQuery(content_slider),
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                },
            }, ],
        });
        jQuery(content_slider).slick({
            slidesToShow: 1,
            infinite: false,
            asNavFor: jQuery(image_nav_slider),
            prevArrow: jQuery(prev_arrow),
            nextArrow: jQuery(next_arrow),
        });

        function beforeupdateSlideClasses() {
            const slides = jQuery(
                ".images_slider_with_content_inner_wrapper.content_slide .images_slider .image_slide_list"
            );

            // Get the index of the current slide
            const activeIndex = slides.index(slides.filter(".slick-current"));

            // Update classes for the slides
            slides.each(function(index) {
                jQuery(this).removeClass("current prev next"); // Remove previous classes

                // Add the current class
                if (index === activeIndex) {
                    jQuery(this).addClass("current"); // Current slide
                }
                // Add the prev class
                else if (index === (activeIndex - 1 + slides.length) % slides.length) {
                    jQuery(this).addClass("prev"); // Previous slide
                }
                // Add the next class
                else if (index === (activeIndex + 1) % slides.length) {
                    jQuery(this).addClass("next"); // Next slide
                }
            });
        }

        jQuery(image_nav_slider).on("beforeChange", function() {
            beforeupdateSlideClasses();
        });
        jQuery(image_slider).on("afterChange", function() {
            beforeupdateSlideClasses();
        });
        // jQuery(image_nav_slider).on("afterChange", function () {
        //   updateSlideClasses();
        // });
        // jQuery(image_slider).on("afterChange", function () {
        //   updateSlideClasses();
        // });
    });

    jQuery(".left_content_with_right_image_slider").each(function(index) {
        let slider_main = jQuery(this).find(".image_slider");
        let slide_item = jQuery(this).find(".image_slider_list");
        let next_arrow = jQuery(this).find(".next_arrow");
        // let lastSlide = jQuery(slide_item).last().clone();
        // jQuery(slider_main).prepend(lastSlide);

        if (jQuery(slide_item).length > 2) {
            jQuery(slider_main).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                nextArrow: jQuery(next_arrow),
                dots: false,
                speed: 700,
                variableWidth: true,
                responsive: [{
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                }, ],
            });
        }
        // jQuery(slider_main).on(
        //   "afterChange",
        //   function (event, slick, currentSlide) {
        //     // Remove 'active' class from all slides
        //     jQuery(slide_item).removeClass("active");

        //     // Add 'active' class to only the first visible slide
        //     let firstVisibleSlideIndex = currentSlide; // Get current slide index
        //     jQuery(slide_item).eq(firstVisibleSlideIndex).addClass("active");
        //   }
        // );
    });

    offsetLeft();

    function offsetLeft() {
        var imageSlider = document.querySelector(
            ".left_content_with_right_image_slider .image_slider"
        );
        if (imageSlider) {
            var boxesoffset = imageSlider.getBoundingClientRect().left;
            var boxeswindWidth = window.innerWidth;
            imageSlider.style.width = boxeswindWidth - boxesoffset + "px";
        }
    }
    window.addEventListener("resize", offsetLeft);
    // function offsetBothSides() {
    //   var imageSlider = document.querySelector(
    //     ".images_slider_with_content_inner_wrapper.content_slide .images_slider"
    //   );

    //   if (imageSlider) {
    //     // Get the bounding rectangle of the image slider
    //     var rect = imageSlider.getBoundingClientRect();

    //     // Calculate the left and right offsets from the viewport
    //     var leftOffset = rect.left; // Distance from the left edge of the viewport
    //     var rightOffset = window.innerWidth - rect.right; // Distance from the right edge of the viewport

    //     // Set the new width of the image slider based on visible space on both sides
    //     imageSlider.style.width =
    //       window.innerWidth - leftOffset - rightOffset + "px";
    //   }
    // }

    // // Call the function when the DOM is loaded and on resize
    // window.addEventListener("resize", offsetBothSides);
    jQuery(".background_image_with_content_box").each(function(index) {
        let list_slider = jQuery(this).find(".background_image_with_content_slider");
        jQuery(list_slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            dots: true,
        });
    });
});

// //-- HEIGHT--//

// document.addEventListener("DOMContentLoaded", function () {
//   // Select the two div elements
//   var imagePositionLeft = document.querySelector(
//     ".image_position_left .right_sec_inner"
//   );
//   var imagePositionRight = document.querySelector(
//     ".image_position_right .right_sec_inner"
//   );

//   function adjustHeight() {
//     // Get the heights of both boxes
//     var height1 = imagePositionLeft.scrollHeight;
//     var height2 = imagePositionRight.scrollHeight;

//     // Set both boxes to the maximum height
//     var maxHeight = Math.max(height1, height2);
//     imagePositionLeft.style.height = maxHeight + "px";
//     imagePositionRight.style.height = maxHeight + "px";
//   }

//   // Initial adjustment when the page loads
//   adjustHeight();

//   // Adjust the height when the window is resized
//   window.addEventListener("resize", adjustHeight);

//   // Create MutationObservers to detect changes in content
//   var observer1 = new MutationObserver(adjustHeight);
//   var observer2 = new MutationObserver(adjustHeight);

//   observer1.observe(imagePositionLeft, {
//     childList: true,
//     subtree: true,
//   });
//   observer2.observe(imagePositionRight, {
//     childList: true,
//     subtree: true,
//   });
// });



//7 add class on an tag  & Body //


document.querySelectorAll(".site_navigation_top .menu-item-has-children").forEach(function(HeaderWrapper) {
    HeaderWrapper.addEventListener("click", function() {

        HeaderWrapper.classList.toggle('sub_menu_active')
    })
})